import type { UseMutationOptions, UseMutationResult } from '@tanstack/react-query'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { upsertTripChatRecentSearch } from 'tripPlanner/api'
import type { TripChatRecentSearch } from 'tripPlanner/api/types'
import type { UpsertTripChatRecentSearchBody } from 'tripPlanner/utils/tripChatRecentSearchPayload'
import * as ChatKeys from '../reactQueryKeys/chat'

export type UpsertTripChatRecentSearchParams = {
  chatId: number
  body: UpsertTripChatRecentSearchBody
}

export type UpsertTripChatRecentSearchResult = TripChatRecentSearch

export const useUpsertTripChatRecentSearchMutation = (
  options?: UseMutationOptions<
    UpsertTripChatRecentSearchResult,
    unknown,
    UpsertTripChatRecentSearchParams
  >,
): UseMutationResult<
  UpsertTripChatRecentSearchResult,
  unknown,
  UpsertTripChatRecentSearchParams
> => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async({ chatId, body }) => upsertTripChatRecentSearch(chatId, body),
    ...options,
    onSuccess: async(data, variables, context) => {
      await queryClient.invalidateQueries({
        queryKey: ChatKeys.itineraryDetail(variables.chatId),
      })
      await options?.onSuccess?.(data, variables, context)
    },
  })
}
